export default {
  LISTS_WITH_USERS: 'LISTS_WITH_USERS',
  LISTS_AND_USERS: 'LISTS_AND_USERS',
  COLLAPSE: 'COLLAPSE',
  INCREMENT_REMOVE_FROM_LIST: 'LISTS_INCREMENT_REMOVE',
  UPDATE_LIST_ORDER: 'LISTS_UPDATE_LIST_ORDER',
  UPDATE_IS_LIST_AVAILABLE: 'LIST_UPDATE_IS_AVAILABLE',
  SET_LAST_MESSAGE_DATE_BEFORE_LIST: 'SET_LAST_MESSAGE_DATE_BEFORE_LIST'
}
